import { render } from "./MerchantIpWhitelistModal.vue?vue&type=template&id=12624178&ts=true"
import script from "./MerchantIpWhitelistModal.vue?vue&type=script&lang=ts"
export * from "./MerchantIpWhitelistModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__